import { useEffect, useState } from "react";

import { getVideoChapterByCurrentTime } from "./getVideoChapterByCurrentTime";

import type { VideoData } from "../types";
import type Player from "video.js/dist/types/player";

export const useGetCurrentChapterNameForVOD = ({
  video,
  player,
}: {
  video: VideoData;
  player: Player;
}): string => {
  const { chapters, videoStartTimeInMilliseconds } = video;

  const playerCurrentTimeInSeconds = player.currentTime();

  const [currentChapterName, setCurrentChapterName] = useState<
    string | undefined
  >(
    playerCurrentTimeInSeconds !== undefined
      ? getVideoChapterByCurrentTime(
          chapters,
          playerCurrentTimeInSeconds * 1000 + videoStartTimeInMilliseconds
        )?.name
      : undefined
  );

  useEffect(() => {
    const setCurrentChapterNameWrapper = () => {
      const playerCurrentTimeInSeconds = player.currentTime();

      if (playerCurrentTimeInSeconds === undefined) {
        return;
      }

      const newChapterName = getVideoChapterByCurrentTime(
        chapters,
        playerCurrentTimeInSeconds * 1000 + videoStartTimeInMilliseconds
      )?.name;

      setCurrentChapterName(newChapterName);
    };

    const intervalId = setInterval(() => {
      setCurrentChapterNameWrapper();
    }, 5000); // 5秒ごとに更新

    const onSeeked = () => {
      setCurrentChapterNameWrapper();
    };

    player.on("seeked", onSeeked);

    return () => {
      player.off("seeked", onSeeked);
      clearInterval(intervalId);
    };
  }, [chapters, player, videoStartTimeInMilliseconds]);

  return currentChapterName ?? video.name;
};
